module.exports = __webpack_public_path__ + "img/home-smile.634d70dc.svg";